import axios, { AxiosResponse } from 'axios';
import { RulesContext } from '../domain/RulesContext';


export interface IRulesApi {
  getAppDataConf(rulesContext:RulesContext): Promise<AxiosResponse<any>>;
}

export class RulesApi implements IRulesApi {
  
  async getAppDataConf(rulesContext:RulesContext): Promise<AxiosResponse<any>> {
    return axios.post('api/rules/getAppDataConf',rulesContext);
  }

}
